/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React,
{
  useState,
  useMemo,
  useEffect,
} from 'react';
import PropTypes from 'prop-types';
import API from 'api';
import Box from '@material-ui/core/Box';
import Ad from 'models/business/Ad';
import classNames from 'classnames';
import FormLabel from 'components/pages/ResourceSetting/Widgets/FormLabel';
import StyledRadioButton from 'components/pages/ResourceSetting/Widgets/StyledRadioButton';
import UndoIcon from '@material-ui/icons/Undo';
// import FormLabel from 'components/pages/ResourceSetting/Widgets/FormLabel';
// import { Categories as PlatformCategories } from 'models/business/Platform';
import GeneralAdCard from './GeneralAdCard';
// import NewAdCard from './NewAdCard';
import Styles from './index.module.css';

const PresentationFilterTitles = {
  Undone: '未排程',
  Online: '已排程',
  Stopped: '已停止',
};

export default function AdDashboard({
  ads,
  amounts,
  activeFilter,
  onChangeAds,
}) {
  const [presentationFormat, setPresentationFormat] = useState(activeFilter);
  const [adsUndone, setAdsUndone] = useState([]);
  const [adsArchive, setAdsArchive] = useState([]);
  const [adsOnline, setAdsOnline] = useState([]);
  const [adsPending, setAdsPending] = useState([]);
  const [adsStopped, setAdsStopped] = useState([]);
  // const [adsTmp, setAdsTmp] = useState([]);
  // const [adsFiltered] = useState([]);
  // const [ads, setAds] = useState([]);

  // const getAdList = async () => {
  //   // const result = await API.ad.postAdList();
  //   const result = await API.ad.postAdList2();
  //   if (result.errorMsg === '0000') {
  //     // setAdsTmp(result.resultData);
  //     setAdsTmp([(result.resultData || []).map((ad) => new Ad(ad))]);
  //     setAdsUndone(adsTmp.filter((a) => a.status === 'Undone'));
  //     setAdsArchive(adsTmp.filter((a) => a.status === 'Archive'));
  //     setAdsOnline(adsTmp.filter((a) => a.status === 'Online'));
  //     setAdsPending(adsTmp.filter((a) => a.status === 'Pending'));
  //     setAdsStopped(adsTmp.filter((a) => a.status === 'Stopped'));
  //     onChangeAds(adsTmp);
  //   } else {
  //     alert(result.error.errorMsg);
  //   }
  // };

  // useEffect(() => {
  //   getAdList();
  // }, []);
  const changeAdStatus = async (id, adStatus) => {
    return;
    // eslint-disable-next-line no-unreachable
    const result = await API.ad.postUpdateAd(
      id,
      null,
      adStatus,
      null,
      null,
      null,
    );

    if (result.errorMsg === '0000') {
      if (adStatus === 'Pending') alert('上搞需求發送成功');
      else if (adStatus === 'Stopped') alert('暫停成功');
      else if (adStatus === 'Inline') alert('更新上搞需求成功');
      // getAdList();
    } else {
      alert(result.error.errorMsg);
    }
  };

  const handleChangeAd = async (newAd) => {
    // alert('handleChangeAd');
    // const index = adsTmp.findIndex((obj) => obj.id === newAd.id);
    // if (index > -1) {
    //   // adsTmp[index] = newAd;
    //   adsTmp.splice(index);
    // }
    // setAdsTmp(adsTmp);
    // console.log(adsTmp.filter((a) => a.status === 'Archive'));
    // getAdList();
    // window.location.reload(false);
    onChangeAds(newAd);
    // setAdsUndone(ads.filter((a) => a.status === 'Undone'));
    // setAdsArchive(ads.filter((a) => a.status === 'Archive'));
  };

  const onChangePresentationFormat = async (format) => {
    setPresentationFormat(format);
  };

  const renderAdUndoneFilter = useMemo(() => (
    <StyledRadioButton
      key="Undone"
      // className={classNames(Styles.formatButtonCollapsed)}
      onClick={() => onChangePresentationFormat('Undone')}
      selected={presentationFormat === 'Undone'}
      className={
        classNames(
          Styles.undoneRadioButton,
          {
            [Styles.undoneRadioButtonSelected]: presentationFormat === 'Undone',
          },
        )
      }
    >
      <div>{PresentationFilterTitles.Undone}</div>
    </StyledRadioButton>
  ));

  const renderAdOnlineFilter = useMemo(() => (
    <StyledRadioButton
      key="Online"
      // className={classNames(Styles.formatButtonCollapsed)}
      onClick={() => onChangePresentationFormat('Online')}
      selected={presentationFormat === 'Online'}
      className={
        classNames(
          Styles.onlineRadioButton,
          {
            [Styles.onlineRadioButtonSelected]: presentationFormat === 'Online',
          },
        )
      }
    >
      <div>{PresentationFilterTitles.Online}</div>
    </StyledRadioButton>
  ));

  const renderAdStoppedFilter = useMemo(() => (
    <StyledRadioButton
      key="Stopped"
      // className={classNames(Styles.formatButtonCollapsed)}
      onClick={() => onChangePresentationFormat('Stopped')}
      selected={presentationFormat === 'Stopped'}
      className={
        classNames(
          Styles.stoppedRadioButton,
          {
            [Styles.stoppedRadioButtonSelected]: presentationFormat === 'Stopped',
          },
        )
      }
    >
      <div>{PresentationFilterTitles.Stopped}</div>
    </StyledRadioButton>
  ));

  const renderAdFilter = useMemo(() => (
    <div className={Styles.mainContainer}>
      <div className={Styles.buttonPanel}>
        {/* {Object.keys(PresentationFilterTitles).map((format) => (
          <StyledRadioButton
            key={format}
            // className={classNames(Styles.formatButtonCollapsed)}
            onClick={() => onChangePresentationFormat(format)}
            selected={presentationFormat === format}
            className={
              classNames(
                Styles.undoneRadioButton,
                {
                  [Styles.undoneRadioButtonSelected]: presentationFormat === 'Undone',
                },
              )
            }
          >
            <div>{PresentationFilterTitles[format]}</div>
          </StyledRadioButton>
        ))} */}
        {renderAdUndoneFilter}
        {renderAdOnlineFilter}
        {renderAdStoppedFilter}
      </div>
    </div>
  ));

  const renderAdCards = useMemo(() => (
    ads.map((ad) => (
      <Box
        mb={2}
        key={ad.id}
      >
        <GeneralAdCard
          ad={new Ad(ad)}
          amounts={amounts}
          onChangeAd={handleChangeAd}
          sendMaterialOnClick={() => changeAdStatus(ad.id, 'Pending')}
          updateMaterialOnClick={() => changeAdStatus(ad.id, 'Inline')}
        />
      </Box>
    ))
  ), [ads]);

  const renderAdCardsUndone = useMemo(() => (
    adsUndone.map((ad) => (
      <Box
        mb={2}
        key={ad.id}
      >
        <GeneralAdCard
          ad={new Ad(ad)}
          amounts={amounts}
          onChangeAd={handleChangeAd}
          sendMaterialOnClick={() => changeAdStatus(ad.id, 'Pending')}
          updateMaterialOnClick={() => changeAdStatus(ad.id, 'Inline')}
          className={classNames(Styles.undoneAdCard)}
        />
      </Box>
    ))
  ), [adsUndone]);

  const renderAdCardsArchive = useMemo(() => (
    adsArchive.map((ad) => (
      <Box
        mb={2}
        key={ad.id}
      >
        <GeneralAdCard
          ad={new Ad(ad)}
          amounts={amounts}
          onChangeAd={handleChangeAd}
          sendMaterialOnClick={() => changeAdStatus(ad.id, 'Pending')}
          updateMaterialOnClick={() => changeAdStatus(ad.id, 'Inline')}
        />
      </Box>
    ))
  ), [adsArchive]);

  const renderAdCardsOnline = useMemo(() => (
    adsOnline.map((ad) => (
      <Box
        mb={2}
        key={ad.id}
      >
        <GeneralAdCard
          ad={new Ad(ad)}
          amounts={amounts}
          onChangeAd={handleChangeAd}
          sendMaterialOnClick={() => changeAdStatus(ad.id, 'Pending')}
          updateMaterialOnClick={() => changeAdStatus(ad.id, 'Inline')}
        />
      </Box>
    ))
  ), [adsOnline]);

  const renderAdCardsPending = useMemo(() => (
    adsPending.map((ad) => (
      <Box
        mb={2}
        key={ad.id}
      >
        <GeneralAdCard
          ad={new Ad(ad)}
          amounts={amounts}
          onChangeAd={handleChangeAd}
          sendMaterialOnClick={() => changeAdStatus(ad.id, 'Pending')}
          updateMaterialOnClick={() => changeAdStatus(ad.id, 'Inline')}
        />
      </Box>
    ))
  ), [adsPending]);

  const renderAdCardsStopped = useMemo(() => (
    adsStopped.map((ad) => (
      <Box
        mb={2}
        key={ad.id}
      >
        <GeneralAdCard
          ad={new Ad(ad)}
          amounts={amounts}
          onChangeAd={handleChangeAd}
          sendMaterialOnClick={() => changeAdStatus(ad.id, 'Pending')}
          updateMaterialOnClick={() => changeAdStatus(ad.id, 'Inline')}
        />
      </Box>
    ))
  ), [adsStopped]);

  useEffect(() => {
    // setAdsTmp(ads);
    setPresentationFormat(activeFilter);
    setAdsUndone(ads.filter((a) => a.status === 'Undone'));
    setAdsArchive(ads.filter((a) => a.status === 'Archive'));
    setAdsOnline(ads.filter((a) => a.status === 'Online'));
    setAdsPending(ads.filter((a) => a.status === 'Pending'));
    setAdsStopped(ads.filter((a) => a.status === 'Stopped'));
  }, [ads]);

  return (
    <Box
      display="flex"
      flexDirection="column"
    >
      <Box
        mb={2}
      >
        {renderAdFilter}
        {/* <NewAdCard /> */}
      </Box>
      {/* {renderAdCards} */}
      {presentationFormat === 'Undone'
      && (
        <FormLabel
          title="未排程廣告"
          description="待完成所有設定後，請按下發送上稿需求，設定廣告開始投放日期"
        />
      )}
      {presentationFormat === 'Undone' && renderAdCardsUndone}
      {/* {presentationFormat === 'Undone'
        && <FormLabel title="封存廣告" description="廣告已封存，若要恢復廣告單元，廣告將恢復為「未排程廣告」" />} */}
      {presentationFormat === 'Undone'
        && (
          <div
            className={classNames(
              Styles.mainContainer,
            )}
          >
            <div style={{ display: 'flex' }}>
              <label
                className={classNames(
                  Styles.title,
                  { [Styles.required]: true },
                )}
                // htmlFor={htmlFor}
              >
                封存廣告
              </label>
            </div>
            <label
              className={classNames(
                Styles.description,
              )}
              // htmlFor={htmlFor}
            >
              廣告已封存，若要恢復廣告單元，請點選右下方恢復按鈕「
              <UndoIcon alt="恢復" style={{ width: '20px', height: '20px' }} />
              」，廣告將恢復為「未排程廣告」
            </label>
          </div>
        )}
      {presentationFormat === 'Undone' && renderAdCardsArchive}
      {presentationFormat === 'Online'
        && <FormLabel title="進行中廣告" description="您的廣告正在進行中，請至【我的成效】查看廣告數據" />}
      {presentationFormat === 'Online' && renderAdCardsOnline}
      {presentationFormat === 'Online'
        && <FormLabel title="已排程廣告，等待上線" description="您的廣告將會在設定的廣告日期開始曝光" />}
      {presentationFormat === 'Online' && renderAdCardsPending}
      {presentationFormat === 'Stopped'
        && <FormLabel title="廣告已停止" description="您的廣告目前暫停中，若想重啟廣告，請按下右下方恢復廣告" />}
      {presentationFormat === 'Stopped' && renderAdCardsStopped}
    </Box>
  );
}

AdDashboard.propTypes = {
  ads: PropTypes.arrayOf(PropTypes.instanceOf(Ad)),
  // eslint-disable-next-line react/forbid-prop-types
  amounts: PropTypes.object,
  activeFilter: PropTypes.string,
  onChangeAds: PropTypes.func,
};

AdDashboard.defaultProps = {
  ads: [],
  amounts: {},
  activeFilter: 'Undone',
  onChangeAds: () => { },
};
